import React from 'react';
import { AutoPropertiesFormComponent } from '@/app/builder/piece-properties/auto-properties-form';
import { SwaggerFetchTokenAuthProperty, SwaggerFetchTokenAuthProps } from '@activepieces/pieces-framework';


type SwaggerFetchTokenConnectionSettingsProps = {
  authProperty: SwaggerFetchTokenAuthProperty<true, SwaggerFetchTokenAuthProps>;
};

const SwaggerFetchTokenConnectionSettings = React.memo(
  ({ authProperty }: SwaggerFetchTokenConnectionSettingsProps) => {
    return (
      <AutoPropertiesFormComponent
        prefixValue="request.value.props"
        props={authProperty.props}
        useMentionTextInput={false}
        allowDynamicValues={false}
        disableHighlight={true}
      />
    );
  },
);

SwaggerFetchTokenConnectionSettings.displayName = 'SwaggerFetchTokenConnectionSettings';
export { SwaggerFetchTokenConnectionSettings }; 